import React from 'react';

import SEOMeta from '@src/components/SEOMeta';

export default function CompanyPage() {
  return (
    <>
      <SEOMeta title="会社概要" description="ICHI-INの会社概要ページです。" />
      <div className="mx-auto max-w-[1000px] bg-white rounded-lg">
        <div className="py-4 my-6">
          <div className="my-6">
            <h1 className="my-4 text-3xl text-center">会社概要</h1>
          </div>

          <div className="overflow-hidden bg-white sm:rounded-md">
            <ul className="list-none divide-y divide-gray-200">
              <TableRaw title="会社名" value="株式会社Ojiiy" />
              <TableRaw title="設立年月日" value="2020年7月" />
              <TableRaw title="代表取締役" value="岸本 航介" />
              <TableRaw
                title="事業内容"
                value="Webメディアの運営, 旅行プラットフォーム事業"
              />
              <TableRaw title="資本金" value="300万円" />
              <TableRaw title="主要取引銀行" value="みずほ銀行" />
              <TableRaw title="本籍地" value="神奈川県鎌倉市" />
              <TableRaw title="お問い合わせ先" value="kishimoto@ojiiy.com" />
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

function TableRaw({ title, value }: { title: string; value: string }) {
  return (
    <li>
      <div className="flex items-center py-4 px-4 sm:px-6">
        <div className="flex flex-1 items-center min-w-0">
          <div className="md:grid flex-1 md:grid-cols-2 md:gap-4 px-4 min-w-0">
            <div className="text-gray-500 md:text-black">{title}</div>
            <div className="block my-2 md:my-0">{value}</div>
          </div>
        </div>
      </div>
    </li>
  );
}
